import React from "react";
import {
  Box,
  Flex,
  Image,
  VStack,
  HStack,
  Heading,
  Text,
  Container,
} from "@chakra-ui/react";
import logo from "../../assets/images/log.png";

import "./styles.css";

const blockDetails = [
  {
    head: "Incredible Gains",
    text: "Make 10x-100x or even 1000x your investment.",
  },
  {
    head: "Warp speed",
    text: "100x in crypto is rare but possible. 100x in a couple of hours? Insane.",
  },
  {
    head: "Affordable to anyone",
    text: "Participate for as little as 50$.",
  },
  {
    head: "Equal chances",
    text: "Play against your equals, not against the house",
  },
  {
    head: "Transparency",
    text: "Clear and simple rules, no cheating, no rug pulls.",
  },
  {
    head: "Fair distribution",
    text: "97% of funds go towards the prize fund.",
  },
];

function index() {
  return (
    <Container maxW="container.xl" mb={32}>
      <Box w="100%">
        <VStack w="100%" spacing={16}>
          <Heading as="h2" size="xl" textShadow="0px 0px 50px #FFFFFF">
            KEY ADVANTAGES
          </Heading>
          <Flex
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            flexDirection={{ base: "column", md: "row" }}
            flexWrap="wrap"
          >
            {blockDetails.map(({ head, text }) => (
              <Blocks key={head} heading={head} text={text} />
            ))}
          </Flex>
          <button id="gButton">
            <a href="https://discord.gg/K346qxBW">Join the Discord</a>
          </button>
        </VStack>
      </Box>
    </Container>
  );
}

function Blocks({ heading, text }) {
  return (
    <Box
      w={{ base: "100%", md: "32%" }}
      // height="250px"
      // bg="radial-gradient(50% 50% at 50% 50%, #213869 13.54%, #110A2E 66.15%)"
      // border="3px solid #7A20AB"
      // borderRadius="15px"
      color="#ffffff"
      my={4}
    >
      <HStack alignItems="flex-start">
        {/* <Box
          borderRadius="100%"
          w="60px"
          border="3px solid #7A20AB"
          height="50px"
        ></Box> */}
        <Image src={logo} w="60px" />
        <VStack
          w="100%"
          spacing={5}
          justifyContent="center"
          alignItems="flex-start"
        >
          <Text fontSize="xl" textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)">
            {heading}
          </Text>
          <Text
            fontWeight="500"
            pr={5}
            textShadow="10px 10px 4px rgba(0, 0, 0, 0.5)"
          >
            {text}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}

export default index;
